import * as actionTypes from './actionTypes';
import getCookiesManager from '../utils/cookiesManager';

export default function hideCookiesBar() {
  if (getCookiesManager()) {
    getCookiesManager().saveValue(true, 'cookiesBarHidden', COUNTRY);
  }
  return {
    type: actionTypes.HIDE_COOKIES_BAR,
  };
}
